import type { Team } from '@cs-shot/battle-sim';

const CLASSES: Record<'text' | 'bg' | 'border', Record<Team, string>> = {
  text: { t: 'text-side-t', ct: 'text-accent-blue' },
  bg: { t: 'bg-side-t/15', ct: 'bg-accent-blue/15' },
  border: { t: 'border-side-t', ct: 'border-accent-blue' },
};

export const sideColor = (side: Team, kind: 'text' | 'bg' | 'border'): string => CLASSES[kind][side];
